import { render, staticRenderFns } from "./alert-listing.vue?vue&type=template&id=6889842f"
import script from "./alert-listing.vue?vue&type=script&lang=js"
export * from "./alert-listing.vue?vue&type=script&lang=js"
import style0 from "./alert-listing.vue?vue&type=style&index=0&id=6889842f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports